import { put, takeEvery } from "redux-saga/effects";
import { GET_ADD_PRODUCT, GET_ADD_RFQ, GET_DELETE_PRODUCT, GET_DELETE_RFQ, GET_DRAFT_ORDERS, GET_ORDERS, GET_ORDERS_DETAIL, GET_RFQ, GET_STATUS, GET_UPDATE_ORDER, GET_UPDATE_RFQ, GET_VALUE, SET_DRAFT_ORDERS, SET_ORDERS, SET_ORDERS_DETAIL, SET_RFQ, SET_STATUS, SET_UPDATE_ORDER, SET_VALUE } from "../ConstAction";
import MycartApiRequests from "../../Services/mycart";
import { storage } from "../../Config/Storage";


function* getrfqs(data) {
    try {
        let response = yield MycartApiRequests.requestrfqs(data?.data);

        yield put({
            type: SET_RFQ,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}


function* getaddrfq(data) {
    try {
        let response = yield MycartApiRequests.requestrfq(data?.data);

        data.setLoading(false)
        data.handleClose();

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getdeleterfq(data) {
    try {
        let response = yield MycartApiRequests.requestdeleterfq(data?.data);

        data.setLoading(false)
    } catch (err) {
        // data.setLoading(false)
    }
}

function* getupdaterfq(data) {
    try {
        let response = yield MycartApiRequests.requestupdaterfq(data?.data);
        storage.destory.rfq()
        storage.destory.rfqID()
        data.setLoading(false)
        data.handleClose();

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getaddproduct(data) {
    try {
        let response = yield MycartApiRequests.requestaddproducts(data?.data, data.payload);
        yield put({
            type: GET_DRAFT_ORDERS,
            data: { session: sessionStorage.getItem("session") },
            setLoading: data.setLoading
        })

    } catch (err) {
    }
}


function* getdeleteproduct(data) {

    try {
        let response = yield MycartApiRequests.requestdeleteproducts(data?.data);
        yield put({
            type: GET_DRAFT_ORDERS,
            data: {
                session: sessionStorage.getItem("session"),
            },
            setLoading: data.setLoading

        })

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getdraftOrders(data) {

    try {
        let response = yield MycartApiRequests.requestdraftorders(data?.data);
        yield put({
            type: SET_DRAFT_ORDERS,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getOrdersDetails(data) {
    try {
        let response = yield MycartApiRequests.requestordersDetails(data?.data);

        yield put({
            type: SET_ORDERS_DETAIL,
            response,
        })
        // data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getOrders(data) {
    try {
        let response = yield MycartApiRequests.requestorders(data?.data);

        yield put({
            type: SET_ORDERS,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}


function* getupdateOrder(data) {

    try {
        let response = yield MycartApiRequests.requestupdateOrder(data);

        yield put({
            type: GET_DRAFT_ORDERS,
            data: { session: sessionStorage.getItem("session") },
            setLoading: data.setLoading
        })

    } catch (err) {
        // data.setLoading(false)
    }
}


function* getStatus(data) {
    try {
        let response = yield MycartApiRequests.requestStatus(data);

        yield put({
            type: SET_STATUS,
            response
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getValue(data) {

    yield put({
        type: SET_VALUE,
        response: data
    })
}

// Defination of all Saga
function* mycartsaga() {
    yield takeEvery(GET_ADD_RFQ, getaddrfq);
    yield takeEvery(GET_RFQ, getrfqs);
    yield takeEvery(GET_DELETE_RFQ, getdeleterfq);
    yield takeEvery(GET_UPDATE_RFQ, getupdaterfq);
    yield takeEvery(GET_ADD_PRODUCT, getaddproduct);
    yield takeEvery(GET_DELETE_PRODUCT, getdeleteproduct);
    yield takeEvery(GET_DRAFT_ORDERS, getdraftOrders);
    yield takeEvery(GET_ORDERS, getOrders);
    yield takeEvery(GET_ORDERS_DETAIL, getOrdersDetails);
    yield takeEvery(GET_UPDATE_ORDER, getupdateOrder);
    yield takeEvery(GET_STATUS, getStatus);
    yield takeEvery(GET_VALUE, getValue);
}
export default mycartsaga;